var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 74,
    viewBox: "0 0 54 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40075 74V62.9205L27.2885 38.9503C29.4902 36.8196 31.3368 34.902 32.8283 33.1974C34.3435 31.4929 35.4917 29.8239 36.2729 28.1903C37.0542 26.5331 37.4448 24.7457 37.4448 22.8281C37.4448 20.6974 36.9595 18.8627 35.9888 17.3239C35.0182 15.7614 33.6924 14.5658 32.0115 13.7372C30.3307 12.8849 28.4249 12.4588 26.2942 12.4588C24.0688 12.4588 22.1275 12.9086 20.4703 13.8082C18.8132 14.7079 17.5347 15.9981 16.6351 17.679C15.7355 19.3598 15.2857 21.3603 15.2857 23.6804H0.690519C0.690519 18.9219 1.7677 14.7907 3.92205 11.2869C6.07641 7.78314 9.09487 5.07244 12.9775 3.15483C16.86 1.23721 21.3345 0.278406 26.4007 0.278406C31.6091 0.278406 36.1427 1.2017 40.0016 3.04829C43.8842 4.87121 46.9026 7.40435 49.057 10.6477C51.2114 13.8911 52.2885 17.608 52.2885 21.7983C52.2885 24.5445 51.744 27.2552 50.655 29.9304C49.5897 32.6056 47.6839 35.5767 44.9377 38.8438C42.1915 42.0871 38.3207 45.9815 33.3255 50.527L22.7076 60.9318V61.429H53.2473V74H1.40075Z",
    fill: "#AC4040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.dba8976d7d3d21780cadc7e1733fd820.svg";
export { ForwardRef as ReactComponent };